import React from 'react';
import { useBoundary } from '~/hooks/useBoundary';
function CoordinateLines() {
    var _a = useBoundary(), width = _a.width, height = _a.height;
    return (React.createElement("svg", { style: { position: 'absolute' }, width: width, height: height }, [
        { color: '#eeeeee', unit: 10 },
        { color: '#cccccc', unit: 100 },
    ].map(function (_a, index) {
        var color = _a.color, unit = _a.unit;
        return (React.createElement(React.Fragment, { key: index },
            Array.from({ length: Math.ceil(height / unit) }).map(function (_, index) {
                var y = index * unit;
                return (React.createElement("line", { key: "".concat('0').concat(y).concat(width).concat(y), x1: '0', y1: y, x2: width, y2: y, style: {
                        stroke: color,
                        strokeWidth: 1,
                    } }));
            }),
            Array.from({ length: Math.ceil(width / unit) }).map(function (_, index) {
                var x = index * unit;
                return (React.createElement("line", { key: "".concat(x).concat('0').concat(x).concat(height), x1: x, y1: '0', x2: x, y2: height, style: {
                        stroke: color,
                        strokeWidth: 1,
                    } }));
            })));
    })));
}
export { CoordinateLines };
